import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CajaService from "../services/CajaService";
import CajaPagosService from "../services/CajaPagosService";
import ReembolsoService from "../services/ReembolsoService";
import EgresosIngresosService from "../services/EgresosIngresosService";
import {
  Grid,
  TextField,
  Paper,
  Typography,
  Stack,
  Box,
  IconButton,
  Tooltip,
  tooltipClasses,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Swal from "sweetalert2";

export const getRegistroCajaId = (resultado = {}) => {
  return (
    resultado?.idCaja ??
    resultado?.idcaja ??
    resultado?.cajaId ??
    resultado?.caja?.idCaja ??
    resultado?.caja?.id ??
    resultado?.idMovimientoCaja ??
    resultado?.idMovimiento ??
    resultado?.id ??
    null
  );
};

export const extractPagosFromResponse = (response) => {
  const payload = response?.data ?? response;

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.pagos)) return payload.pagos;
  if (Array.isArray(payload?.pagosCaja)) return payload.pagosCaja;
  if (Array.isArray(payload?.cajaPagos)) return payload.cajaPagos;
  if (Array.isArray(payload?.data)) return payload.data;

  if (payload && typeof payload === "object") {
    const nested =
      payload.pagos ?? payload.pagosCaja ?? payload.cajaPagos ?? payload.data;
    if (Array.isArray(nested)) return nested;
    if (nested && typeof nested === "object") return [nested];
  }

  return [];
};

const CorteCaja = () => {
  useEffect(() => {
    document.title = "Corte de Caja";
  }, []);

  function mostrarMensaje(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }
  function mostrarMensajeCorte(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.close();
      }
    });
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  function reloadPage() {
    window.location.reload();
  }
  function getFechaHoy() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  const [viewOnly, setViewOnly] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [pagosPorCaja, setPagosPorCaja] = useState({});
  const [reembolsos, setReembolsos] = useState([]);
  const [egresos, setEgresos] = useState([]);
  const [ingresos, setIngresos] = useState([]);
  const [corteGeneral, setCorteGeneral] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabReportes, setActiveTabReportes] = useState(0);
  const [efectivoInicialCaja, setEfectivoInicialCaja] = useState(0);
  const [totalCorte, setTotalCorte] = useState("");
  const [totalCorteDirty, setTotalCorteDirty] = useState(false);
  const [efectivoSiguienteCorte, setEfectivoSiguienteCorte] = useState(0);
  const [notas, setNotas] = useState("");
  const [errorEfectivoInicialCaja, setErrorEfectivoInicialCaja] =
    useState(false);
  const [errorTotalCorte, setErrorTotalCorte] = useState(false);
  const [errorEfectivoSiguienteCorte, setErrorEfectivoSiguienteCorte] =
    useState(false);
  const [corteSeleccionado, setCorteSeleccionado] = useState(null);

  const normalizeMoneyValue = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "string") {
      const cleaned = value.replace(/[$,]/g, "").trim();
      return Number(cleaned) || 0;
    }
    return Number(value) || 0;
  };

  const formatMoney = (value) => {
    const amount = normalizeMoneyValue(value);
    return `$${amount.toFixed(2)}`;
  };

  const getPaymentMethodKey = (value) => {
    const method = `${value ?? ""}`.toLowerCase().trim();
    if (
      ["efectivo", "cash", "contado", "money", "efectivo/contado"].includes(
        method,
      )
    )
      return "efectivo";
    if (
      [
        "tarjeta",
        "card",
        "credito",
        "debito",
        "tarjeta de credito",
        "tarjeta de debito",
        "credit card",
        "debit card",
      ].includes(method)
    )
      return "tarjeta";
    if (["cheque", "check", "cheque bancario"].includes(method))
      return "cheque";
    if (
      [
        "transferencia",
        "transfer",
        "transferencia bancaria",
        "bank transfer",
        "transferencia interbancaria",
      ].includes(method)
    )
      return "transferencia";
    return method;
  };

  const getPaymentMethodFromPago = (pago) =>
    getPaymentMethodKey(
      pago?.metodoPago ??
      pago?.formaPago ??
      pago?.tipoPago ??
      pago?.metodo ??
      pago?.medioPago ??
      pago?.paymentMethod ??
      pago?.tipo,
    );

  const buildCollectorName = (pago) => {
    const parts = [
      pago?.nombreUsuario ||
      pago?.nombreEmpleado ||
      pago?.nombre ||
      pago?.nombreCajero ||
      "",
      pago?.apPaternoUsuario ||
      pago?.apPaternoEmpleado ||
      pago?.apellidoPaterno ||
      pago?.apellidoPaternoUsuario ||
      "",
      pago?.apMaternoUsuario ||
      pago?.apMaternoEmpleado ||
      pago?.apellidoMaterno ||
      pago?.apellidoMaternoUsuario ||
      "",
    ].filter(Boolean);
    return parts.join(" ").trim();
  };

  const getPaymentMethodLabel = (value) => {
    const method = getPaymentMethodKey(value);
    switch (method) {
      case "efectivo":
        return "Efectivo";
      case "tarjeta":
        return "Tarjeta";
      case "cheque":
        return "Cheque";
      case "transferencia":
        return "Transferencia";
      default:
        return `${value ?? "-"}`;
    }
  };

  const getPaymentAmount = (pago) =>
    normalizeMoneyValue(
      pago?.monto ??
      pago?.montoPago ??
      pago?.cantidad ??
      pago?.total ??
      pago?.importe ??
      pago?.importePago ??
      pago?.cantidadRecibida ??
      pago?.montoRecibido ??
      pago?.totalPago ??
      pago?.valor ??
      pago?.abono ??
      pago?.pagado ??
      0,
    );

  const getTransactionCategory = (pago) => {
    const raw =
      `${pago?.tipoTransaccion ?? pago?.tipoMovimiento ?? pago?.tipo ?? pago?.concepto ?? pago?.descripcion ?? ""}`.toLowerCase();
    if (/(gasto|egreso|retiro|compra|pago a|pago)/.test(raw)) return "gasto";
    if (/(ingreso|cobro|reintegro|deposito|venta|abono|recibo)/.test(raw))
      return "ingreso";
    if (/(reembolso|reembols|refund|devolucion)/.test(raw)) return "reembolso";
    return "otro";
  };

  const extractMovimientosCaja = (response) => {
    const payload = response?.data ?? response;

    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.movimientos)) return payload.movimientos;
    if (Array.isArray(payload?.movimientosCaja)) return payload.movimientosCaja;
    if (Array.isArray(payload?.caja)) return payload.caja;
    if (Array.isArray(payload?.data)) return payload.data;

    if (payload && typeof payload === "object") {
      const nested =
        payload.caja ??
        payload.movimientos ??
        payload.movimientosCaja ??
        payload.data;
      if (Array.isArray(nested)) return nested;
      if (nested && typeof nested === "object") return [nested];
    }

    return [];
  };

  const normalizeEgresoIngresoList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (payload && typeof payload === "object") return [payload];
    return [];
  };

  const buildEgresoIngresoUserName = (item) => {
    const parts = [
      item?.nombreUsuario,
      item?.apPaternoUsuario,
      item?.apMaternoUsuario,
    ].filter(Boolean);
    return parts.length ? parts.join(" ").trim() : "-";
  };

  const getEgresoIngresoAmount = (item) =>
    normalizeMoneyValue(item?.cantidad ?? item?.monto ?? item?.importe ?? 0);

  const getPagosForRegistro = (resultado) => {
    const idCaja = getRegistroCajaId(resultado);

    if (!idCaja) return [];
    return Array.isArray(pagosPorCaja[idCaja]) ? pagosPorCaja[idCaja] : [];
  };

  const renderPagosPorMetodo = (pagos, metodo) => {
    const pagosFiltrados = pagos.filter(
      (pago) => getPaymentMethodFromPago(pago) === metodo,
    );
    const totalPorMetodo = pagosFiltrados.reduce(
      (sum, pago) => sum + getPaymentAmount(pago),
      0,
    );

    if (pagosFiltrados.length === 0) {
      return (
        <Typography sx={{ fontWeight: 600, color: "black" }}>$0.00</Typography>
      );
    }

    return (
      <Typography sx={{ fontWeight: 600, color: "black", lineHeight: 1.1 }}>
        {formatMoney(totalPorMetodo)}
      </Typography>
    );
  };

  const renderDetallesCobro = (pagos) => {
    if (!pagos.length) return null;

    return (
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "column",
          gap: "0.08rem",
          alignItems: "center",
          width: "100%",
        }}
      >
        {pagos.map((pago, pagoIndex) => (
          <Box
            key={`cobro-${pagoIndex}`}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: "black",
                lineHeight: 1.1,
                fontSize: "0.6rem",
              }}
            >
              {buildCollectorName(pago) || "Sin datos"}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: "black",
                lineHeight: 1.1,
                fontSize: "0.6rem",
              }}
            >
              {formatMoney(getPaymentAmount(pago))}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "black",
                opacity: 0.8,
                lineHeight: 1.1,
                fontSize: "0.56rem",
              }}
            >
              {pago?.fechaPago ?? pago?.fechaCobro ?? "-"}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  };

  const fetchCaja = async () => {
    if (!currentU?.sucursal) return;

    try {
      const response = await CajaService.getCajaActual(currentU.sucursal);
      const registros = extractMovimientosCaja(response);
      setResultados(registros);
      try {
        const reembolsoResponse = await ReembolsoService.getReembolsoActual(
          currentU.sucursal,
        );
        const reembolsoPayload = reembolsoResponse?.data.reembolsos;
        const reembolsoData = Array.isArray(reembolsoPayload)
          ? reembolsoPayload
          : reembolsoPayload
            ? [reembolsoPayload]
            : [];
        setReembolsos(reembolsoData);
      } catch (error) {
        console.error(error);
        setReembolsos([]);
      }

      try {
        const egresosIngresosResponse =
          await EgresosIngresosService.getEgresosIngresosActual(
            currentU.sucursal,
          );
        const egresosData = normalizeEgresoIngresoList(
          egresosIngresosResponse.data.egresos,
        );
        const ingresosData = normalizeEgresoIngresoList(
          egresosIngresosResponse.data.ingresos,
        );
        setEgresos(egresosData);
        setIngresos(ingresosData);
      } catch (error) {
        console.error(error);
        setEgresos([]);
        setIngresos([]);
      }

      try {
        const corteGeneralResponse = await CajaService.getCorteGeneralActual(
          currentU.sucursal,
        );
        const corteGeneralData = corteGeneralResponse.tabla;
        setCorteGeneral(
          Array.isArray(corteGeneralData) ? corteGeneralData : [],
        );
      } catch (error) {
        console.error(error);
        setCorteGeneral([]);
      }

      const pagosMap = {};
      await Promise.all(
        registros.map(async (registro) => {
          const idCaja = getRegistroCajaId(registro);

          if (!idCaja) return;

          try {
            const pagosResponse =
              await CajaPagosService.getPagosPorCaja(idCaja);
            const pagos = extractPagosFromResponse(pagosResponse);
            pagosMap[idCaja] = pagos;
          } catch (error) {
            console.error(error);
            pagosMap[idCaja] = [];
          }
        }),
      );

      setPagosPorCaja(pagosMap);
    } catch (error) {
      console.error(error);
      mostrarError("No se pudo cargar la información de caja");
    }
  };

  const verCorte = async (corte) => {
    try {
      const idCorte = corte.idCorte;
      const idSucursal = currentU.sucursal;
      setCorteSeleccionado(corte);

      const cajaResponse = await CajaService.getCajaPorCorte(idSucursal, idCorte);
      const registros = extractMovimientosCaja(cajaResponse);
      setResultados(registros);

      try {
        const reembolsoResponse = await ReembolsoService.getReembolsoPorCorte(idSucursal, idCorte);
        const reembolsoPayload = reembolsoResponse?.reembolsos;
        const reembolsoData = Array.isArray(reembolsoPayload)
          ? reembolsoPayload
          : reembolsoPayload
            ? [reembolsoPayload]
            : [];
        setReembolsos(reembolsoData);
      } catch (error) {
        console.error(error);
        setReembolsos([]);
      }

      try {
        const egresosIngresosResponse = await EgresosIngresosService.getEgresosIngresosPorCorte(idSucursal, idCorte);
        const egresosData = normalizeEgresoIngresoList(egresosIngresosResponse.egresos);
        const ingresosData = normalizeEgresoIngresoList(egresosIngresosResponse.ingresos);
        setEgresos(egresosData);
        setIngresos(ingresosData);
      } catch (error) {
        console.error(error);
        setEgresos([]);
        setIngresos([]);
      }

      try {
        const corteGeneralResponse = await CajaService.getCorteGeneral(idSucursal, idCorte);
        const corteGeneralData = corteGeneralResponse.tabla;
        setCorteGeneral(Array.isArray(corteGeneralData) ? corteGeneralData : []);
      } catch (error) {
        console.error(error);
        setCorteGeneral([]);
      }

      const datosCorte = corte;
      const efectivoInicialFromCorte = datosCorte?.efectivoInicial;
      const totalCorteFromCorte = datosCorte?.totalCorteUsuario;
      const efectivoSiguienteFromCorte = datosCorte?.efectivoSiguiente;
      const notasFromCorte = datosCorte?.notas;

      setEfectivoInicialCaja(efectivoInicialFromCorte);
      setTotalCorte(totalCorteFromCorte);
      setEfectivoSiguienteCorte(efectivoSiguienteFromCorte);
      setNotas(notasFromCorte);

      const pagosMap = {};
      await Promise.all(
        registros.map(async (registro) => {
          const idCaja = getRegistroCajaId(registro);
          if (!idCaja) return;
          try {
            const pagosResponse = await CajaPagosService.getPagosPorCaja(idCaja);
            const pagos = extractPagosFromResponse(pagosResponse);
            pagosMap[idCaja] = pagos;
          } catch (error) {
            console.error(error);
            pagosMap[idCaja] = [];
          }
        }),
      );

      setPagosPorCaja(pagosMap);
      setViewOnly(true);
      setEditMode(false);
    } catch (error) {
      console.error(error);
      mostrarError("No se pudo cargar la información del corte");
    }
  };

  const editarCorte = async (corte) => {
    try {
      const idCorte = corte.idCorte;
      const idSucursal = currentU.sucursal;
      setCorteSeleccionado(corte);
      const cajaResponse = await CajaService.getCajaPorCorte(idSucursal, idCorte);
      const registros = extractMovimientosCaja(cajaResponse);
      setResultados(registros);

      try {
        const reembolsoResponse = await ReembolsoService.getReembolsoPorCorte(idSucursal, idCorte);
        const reembolsoPayload = reembolsoResponse?.reembolsos;
        const reembolsoData = Array.isArray(reembolsoPayload)
          ? reembolsoPayload
          : reembolsoPayload
            ? [reembolsoPayload]
            : [];
        setReembolsos(reembolsoData);
      } catch (error) {
        console.error(error);
        setReembolsos([]);
      }

      try {
        const egresosIngresosResponse = await EgresosIngresosService.getEgresosIngresosPorCorte(idSucursal, idCorte);
        const egresosData = normalizeEgresoIngresoList(egresosIngresosResponse.egresos);
        const ingresosData = normalizeEgresoIngresoList(egresosIngresosResponse.ingresos);
        setEgresos(egresosData);
        setIngresos(ingresosData);
      } catch (error) {
        console.error(error);
        setEgresos([]);
        setIngresos([]);
      }

      try {
        const corteGeneralResponse = await CajaService.getCorteGeneral(idSucursal, idCorte);
        const corteGeneralData = corteGeneralResponse.tabla;
        setCorteGeneral(Array.isArray(corteGeneralData) ? corteGeneralData : []);
      } catch (error) {
        console.error(error);
        setCorteGeneral([]);
      }

      const datosCorte = corte;
      const efectivoInicialFromCorte = datosCorte?.efectivoInicial;
      const totalCorteFromCorte = datosCorte?.totalCorteUsuario;
      const efectivoSiguienteFromCorte = datosCorte?.efectivoSiguiente;
      const notasFromCorte = datosCorte?.notas;

      setEfectivoInicialCaja(efectivoInicialFromCorte);
      setTotalCorte(totalCorteFromCorte);
      setEfectivoSiguienteCorte(efectivoSiguienteFromCorte);
      setNotas(notasFromCorte);

      const pagosMap = {};
      await Promise.all(
        registros.map(async (registro) => {
          const idCaja = getRegistroCajaId(registro);
          if (!idCaja) return;
          try {
            const pagosResponse = await CajaPagosService.getPagosPorCaja(idCaja);
            const pagos = extractPagosFromResponse(pagosResponse);
            pagosMap[idCaja] = pagos;
          } catch (error) {
            console.error(error);
            pagosMap[idCaja] = [];
          }
        }),
      );

      setPagosPorCaja(pagosMap);
      setViewOnly(false);
      setEditMode(true);
    } catch (error) {
      console.error(error);
      mostrarError("No se pudo cargar la información del corte");
    }
  };

  useEffect(() => {
    fetchCaja();
  }, []);



  async function mostrarBuscarCortes() {
    let cortesOriginal = [];
    let cortesActivas = [];

    const resultado = await CajaService.getCortes();

    cortesOriginal = resultado.data.cortes;
    cortesActivas = [...cortesOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (cortes) => {
      return cortes
        .map((corte, idx) => {
          return `
        <tr style="background-color: ${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom: 1px solid #e2e8f0; font-size: 0.80rem; transition: background 0.15s;">
          <td style="padding: 6px 10px; text-align: center; font-weight: 600; color: #1e293b; border-right: 1px solid #f1f5f9;">${corte.idCorte}</td>
          <td style="padding: 6px 10px; text-align: left; color: #334155; border-right: 1px solid #f1f5f9;">${corte.nombreSucursal || ""}</td>
          <td style="padding: 6px 12px; text-align: left; font-weight: 500; color: #1e293b; border-right: 1px solid #f1f5f9;">${corte.nombreUsuario} ${corte.apPaternoUsuario} ${corte.apMaternoUsuario}</td>
          <td style="padding: 6px 10px; text-align: center; color: #475569; font-size: 0.78rem; white-space: nowrap; border-right: 1px solid #f1f5f9;">${corte.fechaCorte}</td>
          <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
            <button data-action="mostrar" data-idcorte="${corte.idCorte}" title="Mostrar" style="background: #e0f2fe; color: #0284c7; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-eye"></i>
            </button>
          </td>
          <td style="padding: 4px 6px; text-align: center;">
            <button data-action="editar" data-idcorte="${corte.idCorte}" title="Editar" style="background: #fef3c7; color: #d97706; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-edit"></i>
            </button>
          </td>
        </tr>
      `;
        })
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaCortes = cortesActivas.slice(inicio, fin);
      const tabla = document.getElementById("tablaCortes");
      if (tabla) {
        if (!paginaCortes || paginaCortes.length === 0) {
          tabla.innerHTML = `<tr><td colspan="6" style="padding: 24px; text-align: center; color: #64748b; font-style: italic;">No hay registros</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaCortes);
        }
        tabla
          .querySelectorAll("button[data-action='mostrar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idcorte;
              const corte = cortesActivas.find(
                (item) => String(item.idCorte) === String(id),
              );
              if (corte) {
                verCorte(corte);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='editar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idcorte;
              const corte = cortesActivas.find(
                (item) => String(item.idCorte) === String(id),
              );
              if (corte) {
                editarCorte(corte);
                Swal.close();
              }
            });
          });
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(cortesActivas.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${cortesActivas.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.45" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.45" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "BUSCAR CORTE",
      width: "65%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
        <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; text-align: left;">
          <div style="display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; margin-bottom: 8px;">
            <div style="display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 220px;">
              <label for="swal-nombre" style="font-size: 0.80rem; font-weight: 600; color: #334155;">Fecha del Corte:</label>
              <input id="swal-nombre" type="date" style="padding: 5px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; box-sizing: border-box;" placeholder="" />
            </div>            
            <div>
              <button id="btnMostrarTodos" style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; border: none; border-radius: 6px; font-weight: 600; font-size: 0.80rem; padding: 6px 14px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1); height: 32px; white-space: nowrap; transition: opacity 0.2s;">
                Mostrar todos los cortes
              </button>
            </div>
          </div>
  
          <div style="width: 100%; overflow: auto; max-height: 52vh; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08); background: white;">
            <table class="tablaCortes" style="width: 100%; border-collapse: collapse; text-align: center;">
              <thead>
                <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.80rem; position: sticky; top: 0; z-index: 2;">
                  <th style="padding: 7px 10px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;"># Corte</th>
                  <th style="padding: 7px 10px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Sucursal</th>
                  <th style="padding: 7px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Empleado</th>
                  <th style="padding: 7px 10px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Fecha</th>
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Mostrar</th>
                  <th style="padding: 7px 8px; text-align: center; font-weight: 600; width: 45px;">Editar</th>
                </tr>
              </thead>
              <tbody id="tablaCortes">
              </tbody>
            </table>
          </div>

          <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
            <span id="paginaActual" style="font-size: 0.80rem; color: #64748b; font-weight: 500;"></span>
            <div style="display: flex; gap: 6px;">
              <button id="btnAnterior" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Anterior</button>
              <button id="btnSiguiente" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Siguiente</button>
            </div>
          </div>
        </div>
      `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (
              paginaActual < Math.ceil(cortesActivas.length / porPagina)
            ) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnMostrarTodos")
          .addEventListener("click", async () => {
            try {
              const resultado = await CajaService.getCortes();
              cortesOriginal = resultado.data.cortes;
              cortesActivas = [...cortesOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error al recargar cortes:", error);
            }
            document.getElementById("swal-nombre").value = "";
          });
        document
          .getElementById("swal-nombre")
          .addEventListener("input", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              cortesActivas = [...cortesOriginal];
              renderPagina(paginaActual);
              return;
            }

            try {
              const resultado =
                await CajaService.buscarCortes(valor);
              cortesActivas = resultado.cortes;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error en búsqueda:", error);
            }
          });
      },
    });
  }



  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleTabReportesChange = (event, newValue) => {
    setActiveTabReportes(newValue);
  };

  const handleCrearCorte = async () => {
    try {
      await CajaService.crearCorte(currentU.sucursal);
      await fetchCaja();
    } catch (error) {
      console.error(error);
      mostrarError("No se pudo crear el corte de caja");
    }
  };

  const TabPanel = ({ children, value, index }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  const gastosData = egresos;
  const ingresosData = ingresos;

  // Totales calculados a partir de los resultados
  const totals = resultados.reduce(
    (acc, r) => {
      const sub = Number(r.subtotal ?? 0) || 0;
      const desc = Number(r.descuento ?? 0) || 0;
      const iva = Number(r.iva ?? 0) || 0;
      const pag = Number(r.pagado ?? 0) || 0;
      const ade = Number(r.adeudo ?? 0) || 0;
      const totalSol = Number(r.totalPagar ?? r.total ?? (sub - desc + iva)) || 0;
      acc.subtotal += sub;
      acc.descuento += desc;
      acc.iva += iva;
      acc.totalSolicitud += totalSol;
      acc.pagado += pag;
      acc.adeudo += ade;

      const pagos = getPagosForRegistro(r);
      if (pagos.length === 0) {
        const mp = (r.metodoPago || "").toLowerCase();
        const monto = normalizeMoneyValue(r.montoPago ?? r.monto ?? 0);
        if (mp === "efectivo") acc.efectivo += monto;
        if (mp === "tarjeta") acc.tarjeta += monto;
        if (mp === "cheque") acc.cheque += monto;
        if (mp === "transferencia") acc.transferencia += monto;
      } else {
        pagos.forEach((pago) => {
          const mp = getPaymentMethodFromPago(pago);
          const monto = getPaymentAmount(pago);
          if (mp === "efectivo") acc.efectivo += monto;
          if (mp === "tarjeta") acc.tarjeta += monto;
          if (mp === "cheque") acc.cheque += monto;
          if (mp === "transferencia") acc.transferencia += monto;
        });
      }

      return acc;
    },
    {
      subtotal: 0,
      descuento: 0,
      iva: 0,
      totalSolicitud: 0,
      pagado: 0,
      adeudo: 0,
      efectivo: 0,
      tarjeta: 0,
      cheque: 0,
      transferencia: 0,
    },
  );

  const totalReembolsos = reembolsos.reduce(
    (sum, item) =>
      sum +
      normalizeMoneyValue(item?.monto ?? item?.cantidad ?? item?.importe ?? 0),
    0,
  );

  const totalGastosEfectivo = egresos.reduce((sum, item) => {
    const metodo = getPaymentMethodKey(
      item?.metodoPago ??
      item?.formaPago ??
      item?.tipoPago ??
      item?.formaDePago ??
      item?.medioPago ??
      item?.paymentMethod ??
      item?.tipo ??
      item?.metodo,
    );
    const operacion =
      `${item?.operacion ?? item?.tipoOperacion ?? item?.tipo ?? item?.movimiento ?? item?.concepto ?? item?.descripcion ?? ""}`.toLowerCase();
    const esEgreso = /(gasto|egreso|retiro|compra|pago)/.test(operacion);
    return metodo === "efectivo" && esEgreso
      ? sum +
      normalizeMoneyValue(
        item?.cantidad ?? item?.monto ?? item?.importe ?? 0,
      )
      : sum;
  }, 0);

  const totalIngresosEfectivo = ingresos.reduce((sum, item) => {
    const metodo = getPaymentMethodKey(
      item?.metodoPago ??
      item?.formaPago ??
      item?.tipoPago ??
      item?.formaDePago ??
      item?.medioPago ??
      item?.paymentMethod ??
      item?.tipo ??
      item?.metodo,
    );
    const operacion =
      `${item?.operacion ?? item?.tipoOperacion ?? item?.tipo ?? item?.movimiento ?? item?.concepto ?? item?.descripcion ?? ""}`.toLowerCase();
    const esIngreso = /(ingreso|cobro|deposito|venta|abono|recibo)/.test(
      operacion,
    );
    return metodo === "efectivo" && esIngreso
      ? sum +
      normalizeMoneyValue(
        item?.cantidad ?? item?.monto ?? item?.importe ?? 0,
      )
      : sum;
  }, 0);

  const totalEfectivoCaja =
    totals.efectivo -
    totalReembolsos -
    totalGastosEfectivo +
    totalIngresosEfectivo;

  const diffTotalCorte =
    normalizeMoneyValue(totalCorte) - (efectivoInicialCaja + totalEfectivoCaja);
  const diffTotalCorteFormatted = formatMoney(diffTotalCorte);
  const isTotalCorteEqual = Math.abs(diffTotalCorte) < 0.005;
  const totalCorteStatus = isTotalCorteEqual
    ? {
      text: `${formatMoney(0)} Correcto`,
      color: "green",
    }
    : diffTotalCorte < 0
      ? {
        text: `${diffTotalCorteFormatted} Faltante`,
        color: "red",
      }
      : {
        text: `${diffTotalCorteFormatted} Excedente`,
        color: "green",
      };

  const shouldShowTotalCorteStatus = totalCorte !== "";

  const granTotalPagosPorPersonal = corteGeneral.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0,
  );

  const handleGuardarCorte = async () => {
    let corteIns;
    let corteUpd;
    if (
      efectivoInicialCaja === "" &&
      efectivoSiguienteCorte === "" &&
      totalCorte === ""
    ) {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorEfectivoInicialCaja(true);
      setErrorEfectivoSiguienteCorte(true);
      setErrorTotalCorte(true);
    } else if (efectivoInicialCaja === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorEfectivoInicialCaja(true);
    } else if (efectivoSiguienteCorte === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorEfectivoSiguienteCorte(true);
    } else if (totalCorte === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorTotalCorte(true);
    } else {
      corteIns = {
        idSucursal: currentU.sucursal,
        efectivoInicial: efectivoInicialCaja,
        totalCorteUsuario: totalCorte,
        efectivoSiguiente: efectivoSiguienteCorte,
        nota: notas,
        idUsuario: currentU.id,
      };
      corteUpd = {
        idCorte: corteSeleccionado.idCorte,
        efectivoInicial: efectivoInicialCaja,
        totalCorteUsuario: totalCorte,
        efectivoSiguiente: efectivoSiguienteCorte,
        nota: notas,
      };
      try {
        let resultado;
        if (editMode) {
          resultado = await CajaService.updateCorte(corteUpd);
          if (resultado.data.estatus === "OK") {
            mostrarMensajeCorte("Corte modificado con éxito!");
          } else {
            mostrarError(
              "No se pudo modificar el corte: " + resultado.data.mensaje,
            );
          }
        } else {
          resultado = await CajaService.crearCorte(corteIns);
          if (resultado.data.estatus === "OK") {
            mostrarMensajeCorte("Corte agregado con éxito!");
          } else {
            mostrarError(
              "No se pudo agregar el corte: " + resultado.data.mensaje,
            );
          }
        }
      } catch (error) {
        mostrarError("Error al actualizar corte:", error);
      }
    }
  };

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperSol"
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h9"
                    gutterBottom
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      whiteSpace: "pre-line",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ fontWeight: "bold", justifyContent: "center" }}
                    >
                      CORTE DIARIO
                    </Box>
                  </Typography>
                </Box>
              </Grid>

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{
                    paddingTop: "0.6vw",
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <Table sx={{ width: "100%", backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                      {" "}
                      <TableHead sx={{ backgroundColor: "#18234f" }}>
                        <TableRow>
                          <TableCell
                            colSpan={1}
                            align="center"
                            sx={{
                              fontSize: "1.5vw",
                              color: "white",
                              fontWeight: "bold",
                              borderBottom: "none",
                              borderRight: "1px solid #ccc",
                            }}
                          >
                            Sucursal: {currentU.nombreSucursal}
                          </TableCell>
                          <TableCell
                            colSpan={1}
                            align="center"
                            sx={{
                              fontSize: "1.5vw",
                              color: "white",
                              fontWeight: "bold",
                              borderBottom: "none",
                              borderRight: "1px solid #ccc",
                            }}
                          >
                            Fecha de corte: {getFechaHoy()}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody
                        sx={{
                          "& .MuiTableCell-root": { padding: "4px 6px" },
                        }}
                      >
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",

                                  textAlign: "center",
                                }}
                              >
                                Coloque el efectivo inicial en Caja: (El
                                dinero para cambio)
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                value={efectivoInicialCaja}
                                disabled={viewOnly}
                                onChange={(e) =>
                                  setEfectivoInicialCaja(e.target.value)
                                }
                                sx={{
                                  width: "14vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",

                                  textAlign: "center",
                                }}
                              >
                                Total Efectivo en Caja: (Efectivo Solicitudes
                                - Reembolsos - Gastos Efectivo + Ingresos
                                Efectivo)
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",
                                  backgroundColor: "green",
                                  textAlign: "center",
                                }}
                              >
                                {formatMoney(totalEfectivoCaja)}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",

                                  textAlign: "center",
                                }}
                              >
                                Efectivo inicial en Caja + Total en Efectivo
                                en Caja
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",
                                  backgroundColor: "green",
                                  textAlign: "center",
                                }}
                              >
                                {formatMoney(
                                  efectivoInicialCaja + totalEfectivoCaja,
                                )}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",

                                  textAlign: "center",
                                }}
                              >
                                Coloque el total para Corte: (Coloque el total
                                tomando en cuenta el efectivo inicial en caja)
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                disabled={viewOnly}
                                value={totalCorte}
                                onChange={(e) => {
                                  setTotalCorte(e.target.value);
                                  setTotalCorteDirty(true);
                                }}
                                sx={{
                                  width: "14vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                            </Box>
                            {shouldShowTotalCorteStatus && (
                              <Box sx={{ mt: 1, textAlign: "center" }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: totalCorteStatus.color,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {totalCorteStatus.text}
                                </Typography>
                              </Box>
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",

                                  textAlign: "center",
                                }}
                              >
                                Coloque el efectivo inicial para el siguiente
                                corte:
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                disabled={viewOnly}
                                value={efectivoSiguienteCorte}
                                onChange={(e) =>
                                  setEfectivoSiguienteCorte(e.target.value)
                                }
                                sx={{
                                  width: "14vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                variant="h9"
                                gutterBottom
                                sx={{
                                  fontWeight: "bold",
                                  color: "black",
                                  padding: "0.5vw 1vw",
                                  borderRadius: "8px",
                                  display: "inline-block",

                                  textAlign: "center",
                                }}
                              >
                                Notas
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                disabled={viewOnly}
                                value={notas}
                                onChange={(e) => setNotas(e.target.value)}
                                multiline
                                minRows={1}
                                maxRows={4}
                                sx={{
                                  width: "14vw",
                                  "& .MuiInputBase-root": {},
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "85vw" }}
              className="paperReportes"
            >
              <Box sx={{ width: "100%" }}>
                <Table
                  size="small"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    tableLayout: "fixed",
                    backgroundColor: "white",
                    "& th, & td": {
                      padding: "0.28vw 0.45vw",
                      fontSize: "0.8vw",
                      lineHeight: 1.15,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                    "& th": {
                      fontSize: "0.8vw",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    },
                    "& td": {
                      whiteSpace: "nowrap",
                    },
                    "& td.patient, & th.patient": {
                      whiteSpace: "normal",
                    },
                    "& td.cobro, & th.cobro": {
                      whiteSpace: "normal",
                    },
                  }}
                >
                  {" "}
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        colSpan={13}
                        sx={{
                          color: "white",
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          textAlign: "center",
                          fontSize: "1vw",
                        }}
                      >
                        DETALLE DE SOLICITUDES DE ESTUDIOS
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                        }}
                      >
                        No. Solicitud
                      </TableCell>
                      <TableCell
                        className="patient"
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "7.5rem",
                        }}
                      >
                        Paciente
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "4rem",
                        }}
                      >
                        Subtotal
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "4rem",
                        }}
                      >
                        Descuentos
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "4rem",
                        }}
                      >
                        IVA
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "4.5rem",
                        }}
                      >
                        Total
                        <br />
                        solicitud
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "4rem",
                        }}
                      >
                        Pagado
                        <br />
                        hasta hoy
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "3.8rem",
                        }}
                      >
                        Adeudos
                      </TableCell>
                      <TableCell
                        className="status"
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                          minWidth: "4rem",
                        }}
                      >
                        Estatus
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "5vw",
                        }}
                        colSpan={4}
                      >
                        Pagos recibidos hoy en caja
                      </TableCell>
                      <TableCell
                        className="cobro"
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.5vw",
                        }}
                      >
                        Realizó
                        <br />
                        cobro
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Efectivo
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Tarjeta
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Cheque
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Transf.
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {resultados.length > 0 ? (
                      <>
                        {resultados.map((resultado, index) => {
                          const pagos = getPagosForRegistro(resultado);
                          const pacienteNombre =
                            `${resultado.nombrePaciente || ""} ${resultado.apPaternoPaciente || ""} ${resultado.apMaternoPaciente || ""}`.trim();
                          const tienePago = pagos.length > 0;
                          const estadoSolicitud =
                            `${resultado.estadoSolicitud ?? resultado.estatusSolicitud ?? resultado.estatus ?? ""}`
                              .trim()
                              .toUpperCase();
                          const esCancelada =
                            estadoSolicitud === "C" ||
                            /CANCEL/i.test(estadoSolicitud);
                          const textoRojo = esCancelada ? "#d32f2f" : "black";
                          const estatus = esCancelada
                            ? "Cancelada"
                            : resultado.adeudo && Number(resultado.adeudo) === 0
                              ? "Pagada"
                              : resultado.pagado && Number(resultado.pagado) > 0
                                ? "Pagada parcialmente"
                                : "Sin pagos";
                          return (
                            <React.Fragment key={index}>
                              <TableRow>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.5vw 1vw",
                                      borderRadius: "8px",
                                      display: "inline-block",
                                      textAlign: "center",
                                    }}
                                  >
                                    {resultado.codigoSolicitud || "-"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.18rem 0.28rem",
                                      borderRadius: "6px",
                                      display: "inline-block",
                                      textAlign: "center",
                                      whiteSpace: "normal",
                                      overflowWrap: "anywhere",
                                    }}
                                  >
                                    {pacienteNombre || "-"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.2rem 0.3rem",
                                      display: "inline-block",
                                      textAlign: "center",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatMoney(resultado.subtotal)}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.2rem 0.3rem",
                                      display: "inline-block",
                                      textAlign: "center",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatMoney(resultado.descuento)}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.2rem 0.3rem",
                                      display: "inline-block",
                                      textAlign: "center",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatMoney(resultado.iva ?? 0)}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.2rem 0.3rem",
                                      display: "inline-block",
                                      textAlign: "center",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatMoney(
                                      Number(
                                        resultado.totalPagar ??
                                        resultado.total ??
                                        (Number(resultado.subtotal || 0) -
                                          Number(resultado.descuento || 0) +
                                          Number(resultado.iva || 0)),
                                      ).toFixed(2),
                                    )}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.2rem 0.3rem",
                                      display: "inline-block",
                                      textAlign: "center",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatMoney(resultado.pagado)}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="h9"
                                    gutterBottom
                                    sx={{
                                      fontWeight: "bold",
                                      color: "black",
                                      padding: "0.2rem 0.3rem",
                                      display: "inline-block",
                                      textAlign: "center",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatMoney(resultado.adeudo)}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "inline-flex",
                                      flexDirection: "column",
                                      gap: "0.1rem",
                                      alignItems: "center",
                                      whiteSpace: "normal",
                                      overflowWrap: "anywhere",
                                    }}
                                  >
                                    {estatus.split(" ").map((line, idx) => (
                                      <Typography
                                        key={idx}
                                        variant="h9"
                                        sx={{
                                          fontWeight: "600",
                                          color: textoRojo,
                                          lineHeight: 1.1,
                                        }}
                                      >
                                        {line}
                                      </Typography>
                                    ))}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      minHeight: "1.2rem",
                                    }}
                                  >
                                    {renderPagosPorMetodo(pagos, "efectivo")}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      minHeight: "1.2rem",
                                    }}
                                  >
                                    {renderPagosPorMetodo(pagos, "tarjeta")}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      minHeight: "1.2rem",
                                    }}
                                  >
                                    {renderPagosPorMetodo(pagos, "cheque")}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      minHeight: "1.2rem",
                                    }}
                                  >
                                    {renderPagosPorMetodo(
                                      pagos,
                                      "transferencia",
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell
                                  className="cobro"
                                  sx={{
                                    width: "2vw",
                                    padding: "0.18rem 0.2rem",
                                  }}
                                >
                                  {tienePago
                                    ? renderDetallesCobro(pagos)
                                    : null}
                                </TableCell>
                              </TableRow>
                              {resultado.motivoDescuentoSolicitud ? (
                                <TableRow>
                                  <TableCell
                                    colSpan={14}
                                    sx={{
                                      backgroundColor: "#f5f5f5",
                                      padding: "0.35rem 0.5rem",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#333", fontWeight: 700, fontSize: "0.8vw" }}
                                    >
                                      MOTIVO DEL DESCUENTO:{" "}
                                      {resultado.motivoDescuentoSolicitud}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                            </React.Fragment>
                          );
                        })}

                        {/* Fila de totales */}
                        <TableRow sx={{ backgroundColor: "#e9f2f9" }}>
                          <TableCell
                            colSpan={2}
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            Total de solicitudes
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            {formatMoney(totals.subtotal.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            {formatMoney(totals.descuento.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            {formatMoney(totals.iva.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            {formatMoney(totals.totalSolicitud.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            {formatMoney(totals.pagado.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            {formatMoney(totals.adeudo.toFixed(2))}
                          </TableCell>
                          <TableCell />
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(totals.efectivo.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(totals.tarjeta.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(totals.cheque.toFixed(2))}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(totals.transferencia.toFixed(2))}
                          </TableCell>
                          <TableCell />
                        </TableRow>
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={13} align="center" sx={{ py: 4 }}>
                          No hay registros
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Paper>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "85vw", mt: 2 }}
              className="paperReportes"
            >
              <Box sx={{ width: "100%" }}>
                <Table
                  size="small"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    tableLayout: "fixed",
                    backgroundColor: "white",
                    "& th, & td": {
                      padding: "0.28vw 0.45vw",
                      fontSize: "0.8vw",
                      lineHeight: 1.15,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                    "& th": {
                      fontSize: "0.8vw",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    },
                    "& td": {
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          color: "white",
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        DETALLE DE REEMBOLSOS
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1vw",
                        }}
                      >
                        Código
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5rem",
                        }}
                      >
                        Fecha
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "2vw",
                          minWidth: "8rem",
                        }}
                      >
                        Motivo
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5rem",
                        }}
                      >
                        Cantidad reembolsado
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "6rem",
                        }}
                      >
                        Forma de reembolso
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          width: "1.5vw",
                          minWidth: "6rem",
                        }}
                      >
                        Reembolso
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reembolsos.length > 0 ? (
                      <>
                        {reembolsos.map((reembolso, index) => (
                          <TableRow key={`reembolso-${index}`}>
                            <TableCell>
                              {reembolso?.idReembolso ?? "-"}
                            </TableCell>
                            <TableCell>{reembolso?.fecha ?? "-"}</TableCell>
                            <TableCell>{reembolso?.motivo ?? "-"}</TableCell>
                            <TableCell>
                              {formatMoney(reembolso?.monto ?? 0)}
                            </TableCell>
                            <TableCell>{reembolso?.formaPago ?? "-"}</TableCell>
                            <TableCell>
                              {reembolso.nombreUsuario +
                                " " +
                                reembolso.apPaternoUsuario +
                                " " +
                                reembolso.apMaternoUsuario ?? "-"}
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: "#e9f2f9" }}>
                          <TableCell
                            colSpan={3}
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            TOTAL DE REEMBOLSOS
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(
                              reembolsos.reduce(
                                (sum, reembolso) =>
                                  sum + normalizeMoneyValue(reembolso?.monto),
                                0,
                              ),
                            )}
                          </TableCell>
                          <TableCell colSpan={2} />
                        </TableRow>
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                          No hay reembolsos
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Paper>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "85vw", mt: 2 }}
              className="paperReportes"
            >
              <Box sx={{ width: "100%" }}>
                <Table
                  size="small"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    tableLayout: "fixed",
                    backgroundColor: "white",
                    "& th, & td": {
                      padding: "0.28vw 0.45vw",
                      fontSize: "0.8vw",
                      lineHeight: 1.15,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                    "& th": {
                      fontSize: "0.8vw",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    },
                    "& td": {
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          color: "#3f2f00",
                          background:
                            "linear-gradient(90deg, #ffd54f, #ffecb3)",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        DETALLE DE GASTOS
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "0.9vw",
                          minWidth: "4.5rem",
                        }}
                      >
                        CÓDIGO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.5vw",
                          minWidth: "6rem",
                        }}
                      >
                        EMPLEADO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "2vw",
                          minWidth: "8rem",
                        }}
                      >
                        CONCEPTO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5rem",
                        }}
                      >
                        CANTIDAD
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.4vw",
                          minWidth: "6rem",
                        }}
                      >
                        FORMA DE PAGO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          width: "1.3vw",
                          minWidth: "6rem",
                        }}
                      >
                        OPERACIÓN
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {gastosData.length > 0 ? (
                      <>
                        {gastosData.map((item, index) => (
                          <TableRow key={`gasto-${index}`}>
                            <TableCell>
                              {item?.idEgresoIngreso ?? "-"}
                            </TableCell>
                            <TableCell>
                              {buildEgresoIngresoUserName(item)}
                            </TableCell>
                            <TableCell>{item?.concepto ?? "-"}</TableCell>
                            <TableCell>
                              {formatMoney(getEgresoIngresoAmount(item))}
                            </TableCell>
                            <TableCell>{item?.formaPago ?? "-"}</TableCell>
                            <TableCell>{item?.operacion ?? "-"}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: "#fff8e1" }}>
                          <TableCell
                            colSpan={3}
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            TOTAL GASTOS
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(
                              gastosData.reduce(
                                (sum, item) =>
                                  sum + getEgresoIngresoAmount(item),
                                0,
                              ),
                            )}
                          </TableCell>
                          <TableCell colSpan={2} />
                        </TableRow>
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                          No hay gastos
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Paper>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "85vw", mt: 2 }}
              className="paperReportes"
            >
              <Box sx={{ width: "100%" }}>
                <Table
                  size="small"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    tableLayout: "fixed",
                    backgroundColor: "white",
                    "& th, & td": {
                      padding: "0.28vw 0.45vw",
                      fontSize: "0.8vw",
                      lineHeight: 1.15,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                    "& th": {
                      fontSize: "0.8vw",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    },
                    "& td": {
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          color: "#3f2f00",
                          background:
                            "linear-gradient(90deg, #ffd54f, #ffecb3)",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        DETALLE DE INGRESOS
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "0.9vw",
                          minWidth: "4.5rem",
                        }}
                      >
                        CÓDIGO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.5vw",
                          minWidth: "6rem",
                        }}
                      >
                        EMPLEADO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "2vw",
                          minWidth: "8rem",
                        }}
                      >
                        CONCEPTO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5rem",
                        }}
                      >
                        CANTIDAD
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.4vw",
                          minWidth: "6rem",
                        }}
                      >
                        FORMA DE PAGO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          width: "1.3vw",
                          minWidth: "6rem",
                        }}
                      >
                        OPERACIÓN
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ingresosData.length > 0 ? (
                      <>
                        {ingresosData.map((item, index) => (
                          <TableRow key={`ingreso-${index}`}>
                            <TableCell>
                              {item?.idEgresoIngreso ?? "-"}
                            </TableCell>
                            <TableCell>
                              {buildEgresoIngresoUserName(item)}
                            </TableCell>
                            <TableCell>{item?.concepto ?? "-"}</TableCell>
                            <TableCell>
                              {formatMoney(getEgresoIngresoAmount(item))}
                            </TableCell>
                            <TableCell>{item?.formaPago ?? "-"}</TableCell>
                            <TableCell>{item?.operacion ?? "-"}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: "#fff8e1" }}>
                          <TableCell
                            colSpan={3}
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            TOTAL INGRESOS
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(
                              ingresosData.reduce(
                                (sum, item) =>
                                  sum + getEgresoIngresoAmount(item),
                                0,
                              ),
                            )}
                          </TableCell>
                          <TableCell colSpan={2} />
                        </TableRow>
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                          No hay ingresos
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Paper>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "85vw", mt: 2 }}
              className="paperReportes"
            >
              <Box sx={{ width: "100%" }}>
                <Table
                  size="small"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    tableLayout: "fixed",
                    backgroundColor: "white",
                    "& th, & td": {
                      padding: "0.28vw 0.45vw",
                      fontSize: "0.8vw",
                      lineHeight: 1.15,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                    "& th": {
                      fontSize: "0.8vw",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    },
                    "& td": {
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        sx={{
                          color: "#3f2f00",
                          background:
                            "linear-gradient(90deg, #ffd54f, #ffecb3)",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        DETALLE DE PAGOS RECIBIDOS POR PERSONAL
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.8vw",
                          minWidth: "7rem",
                        }}
                      >
                        EMPLEADO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5.5rem",
                        }}
                      >
                        TIPO DE PAGO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "0.9vw",
                          minWidth: "4.5rem",
                        }}
                      >
                        CANTIDAD
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5.5rem",
                        }}
                      >
                        GASTOS EFECTIVO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5.5rem",
                        }}
                      >
                        INGRESOS EFECTIVO
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "4.5rem",
                        }}
                      >
                        GASTOS
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "4.5rem",
                        }}
                      >
                        INGRESOS
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                          width: "1.2vw",
                          minWidth: "5rem",
                        }}
                      >
                        REEMBOLSOS
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          width: "1.2vw",
                          minWidth: "4.5rem",
                        }}
                      >
                        TOTAL
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {corteGeneral.length > 0 ? (
                      <>
                        {corteGeneral.map((row, index) => (
                          <TableRow key={`pago-personal-${index}`}>
                            <TableCell>{row.empleado}</TableCell>
                            <TableCell>{row.tipoPago}</TableCell>
                            <TableCell>{row.cantidad}</TableCell>
                            <TableCell>
                              {formatMoney(row.gastosEfectivo)}
                            </TableCell>
                            <TableCell>
                              {formatMoney(row.ingresosEfectivo)}
                            </TableCell>
                            <TableCell>
                              {formatMoney(row.gastosOtros)}
                            </TableCell>
                            <TableCell>
                              {formatMoney(row.ingresosOtros)}
                            </TableCell>
                            <TableCell>{formatMoney(row.reembolsos)}</TableCell>
                            <TableCell>{formatMoney(row.total)}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: "#fff8e1" }}>
                          <TableCell
                            colSpan={2}
                            sx={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            GRAN TOTAL
                          </TableCell>
                          <TableCell />
                          <TableCell />
                          <TableCell />
                          <TableCell />
                          <TableCell />
                          <TableCell />
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              textAlign: "center",
                              backgroundColor: "#0b5394",
                              color: "white",
                            }}
                          >
                            {formatMoney(granTotalPagosPorPersonal)}
                          </TableCell>
                        </TableRow>
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                          No hay pagos por personal
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Paper>
          </Stack>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Guardar corte"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    fontFamily: "Roboto-Medium",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                onClick={handleGuardarCorte}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <SaveIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            title={"Nuevo corte"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={reloadPage}
            >
              <AddIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={"Buscar corte"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              onClick={mostrarBuscarCortes}
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};
export default CorteCaja;
